import { pipe, map } from "rxjs"
import { AssignationStatus, LeadAssignation } from "src/app/core/models/lead/lead-assignation.model"
import { LeadAssignationDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead-assignation.dto"
import { userDtoToUserProfile } from "../user-model-dto/user-profile-dto.mapping"

export const mapLeadAssignationDtoToLeadAssignation = pipe(
    map((source: LeadAssignationDto) => leadAssignationDtoToLeadAssignation(source))
)

export function leadAssignationDtoToLeadAssignation(source: LeadAssignationDto): LeadAssignation | null {
    if (!source) return null
    return {
        assignor: source.assignor ? userDtoToUserProfile(source.assignor) : null,
        assignee: source.assignee ? userDtoToUserProfile(source.assignee) : null,

        status: AssignationStatus[source.status as keyof typeof AssignationStatus],

        deadline: new Date(source.deadline),
        created: new Date(source.created),
        updated: new Date(source.updated)
    } as LeadAssignation
}